import type { RouteRecordRaw, Router } from 'vue-router'

const BuyContractRoutes: RouteRecordRaw = {
  path: '/contract/financial/mudaraba',
  name: 'mudarabaModulePages',
  children: [
    {
      path: '',
      name: 'mudarabaMainRoute',
      component: () => import('./views/MudarabaView.vue'),
      meta: {
        title: 'mudaraba.mudarabaContract',
      },
    },
    {
      path: 'create',
      name: 'MudarabaCreateRoute',
      component: () => import('./views/MudarabaUpsertView.vue'),
      meta: {
        title: 'mudaraba.createViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:mudarabaId',
      name: 'MudarabaEditRoute',
      component: () => import('./views/MudarabaUpsertView.vue'),
      meta: {
        title: 'mudaraba.editViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:mudarabaId',
      name: 'ViewMudarabaRoute',
      component: () => import('./views/SingleMudarabaView.vue'),
      meta: {
        title: 'mudaraba.singleViewTitle',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BuyContractRoutes)
}
